<template>
  <div class="task-system-modal">
    <!-- 顶部操作栏 -->
    <div class="modal-header-actions">
      <ButtonGroup>
        <Button
          @click="refreshAllTasks"
          size="small"
          type="primary"
          icon="md-refresh"
        >
          刷新任务
        </Button>
        <Button
          size="small"
          type="info"
          ghost
          @click="showTaskStatistics = !showTaskStatistics"
        >
          任务统计
        </Button>
      </ButtonGroup>

      <div v-if="showTaskStatistics" class="task-statistics-modal">
        <span class="stat-item">
          <Icon type="ios-list" />
          总任务: {{ totalTaskCount }}
        </span>
        <span class="stat-item completed">
          <Icon type="ios-checkmark-circle" />
          已完成: {{ completedTaskCount }}
        </span>
        <span class="stat-item uncompleted">
          <Icon type="ios-radio-button-on" />
          进行中: {{ uncompletedTaskCount }}
        </span>
      </div>
    </div>

    <div class="task-container-modal">
      <!-- 常规任务内容 -->
      <div v-if="activeTab === 'normal'" class="tab-pane">
        <Row :gutter="24">
          <Col span="8">
            <!-- 常规任务菜单 -->
            <Card class="task-menu-card" :bordered="false">
              <Menu
                :theme="theme"
                :open-names="openNames"
                accordion
                @on-select="handleTaskSelect"
                class="compact-menu"
              >
                <!-- 主线任务 -->
                <Submenu name="1">
                  <template #title>
                    <div class="menu-title">
                      <Icon type="md-alert" />
                      <span>主线</span>
                      <!--                        <Badge
                                                v-if="getUncompletedCount(playersList1) > 0"
                                                :count="getUncompletedCount(playersList1)"
                                                class="menu-badge"
                                              />-->
                    </div>
                  </template>

                  <MenuGroup v-if="getUncompletedTasks(playersList1).length > 0" title="进行中">
                    <MenuItem
                      v-for="item in getUncompletedTasks(playersList1)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="uncompleted-task compact-menu-item"
                    >
                      <Icon type="ios-radio-button-on" color="#ff4d4f" />
                      <span class="task-name">{{ item.taskName }}</span>
                    </MenuItem>
                  </MenuGroup>

                  <MenuGroup v-if="getCompletedTasks(playersList1).length > 0" title="已完成">
                    <MenuItem
                      v-for="item in getCompletedTasks(playersList1)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="completed-task compact-menu-item"
                    >
                      <Icon type="ios-checkmark-circle" color="#52c41a" />
                      <span class="task-name">{{ item.taskName }}</span>
                    </MenuItem>
                  </MenuGroup>

                  <div v-if="playersList1.length === 0" class="empty-tasks">
                    <p>暂无主线</p>
                  </div>
                </Submenu>

                <!-- 支线任务 -->
                <Submenu name="2">
                  <template #title>
                    <div class="menu-title">
                      <Icon type="ios-alert" />
                      <span>支线</span>
                      <!--                        <Badge
                                                v-if="getUncompletedCount(playersList4) > 0"
                                                :count="getUncompletedCount(playersList4)"
                                                class="menu-badge"
                                              />-->
                    </div>
                  </template>

                  <MenuGroup v-if="getUncompletedTasks(playersList4).length > 0" title="进行中">
                    <MenuItem
                      v-for="item in getUncompletedTasks(playersList4)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="uncompleted-task compact-menu-item"
                    >
                      <Icon type="ios-radio-button-on" color="#ff4d4f" />
                      <span class="task-name">{{ item.taskName }}</span>
                    </MenuItem>
                  </MenuGroup>

                  <MenuGroup v-if="getCompletedTasks(playersList4).length > 0" title="已完成">
                    <MenuItem
                      v-for="item in getCompletedTasks(playersList4)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="completed-task compact-menu-item"
                    >
                      <Icon type="ios-checkmark-circle" color="#52c41a" />
                      <span class="task-name">{{ item.taskName }}</span>
                    </MenuItem>
                  </MenuGroup>

                  <div v-if="playersList4.length === 0" class="empty-tasks">
                    <p>暂无支线</p>
                  </div>
                </Submenu>

                <!-- 日常任务 -->
                <Submenu name="4">
                  <template #title>
                    <div class="menu-title">
                      <Icon type="ios-ionic-outline" />
                      <span>日常</span>
                      <!--                        <Badge
                                                v-if="getUncompletedCount(playersList2) > 0"
                                                :count="getUncompletedCount(playersList2)"
                                                class="menu-badge"
                                              />-->
                    </div>
                  </template>

                  <MenuGroup v-if="getUncompletedTasks(playersList2).length > 0" title="今日任务">
                    <MenuItem
                      v-for="item in getUncompletedTasks(playersList2)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="uncompleted-task compact-menu-item"
                    >
                      <Icon type="ios-radio-button-on" color="#ff4d4f" />
                      <span class="task-name">{{ item.taskName }}</span>
                      <Tag v-if="item.statusMsg" size="small" color="orange">{{ item.statusMsg }}</Tag>
                    </MenuItem>
                  </MenuGroup>

                  <MenuGroup v-if="getCompletedTasks(playersList2).length > 0" title="今日已完成">
                    <MenuItem
                      v-for="item in getCompletedTasks(playersList2)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="completed-task compact-menu-item"
                    >
                      <Icon type="ios-checkmark-circle" color="#52c41a" />
                      <span class="task-name">{{ item.taskName }}</span>
                      <Tag v-if="item.statusMsg" size="small" color="green">{{ item.statusMsg }}</Tag>
                    </MenuItem>
                  </MenuGroup>

                  <div v-if="playersList2.length === 0" class="empty-tasks">
                    <p>今日暂无日常任务</p>
                  </div>
                </Submenu>

                <!-- 宗门任务 -->
                <Submenu name="3">
                  <template #title>
                    <div class="menu-title">
                      <Icon type="ios-map-outline" />
                      <span>宗门</span>
                      <!--                        <Badge
                                                v-if="getUncompletedCount(playersList3) > 0"
                                                :count="getUncompletedCount(playersList3)"
                                                class="menu-badge"
                                              />-->
                    </div>
                  </template>

                  <MenuGroup v-if="getUncompletedTasks(playersList3).length > 0" title="进行中">
                    <MenuItem
                      v-for="item in getUncompletedTasks(playersList3)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="uncompleted-task compact-menu-item"
                    >
                      <Icon type="ios-radio-button-on" color="#ff4d4f" />
                      <span class="task-name">{{ item.taskName }}</span>
                      <Tag v-if="item.statusMsg" size="small" color="orange">{{ item.statusMsg }}</Tag>
                    </MenuItem>
                  </MenuGroup>

                  <MenuGroup v-if="getCompletedTasks(playersList3).length > 0" title="已完成">
                    <MenuItem
                      v-for="item in getCompletedTasks(playersList3)"
                      :key="item.taskId"
                      :name="item.taskId"
                      class="completed-task compact-menu-item"
                    >
                      <Icon type="ios-checkmark-circle" color="#52c41a" />
                      <span class="task-name">{{ item.taskName }}</span>
                      <Tag v-if="item.statusMsg" size="small" color="green">{{ item.statusMsg }}</Tag>
                    </MenuItem>
                  </MenuGroup>

                  <div v-if="playersList3.length === 0" class="empty-tasks">
                    <p>暂无宗门任务</p>
                  </div>
                </Submenu>
              </Menu>
            </Card>
          </Col>

          <Col span="16">
            <Card class="task-detail-card" :bordered="false">
              <!-- 常规任务详情 -->
              <div v-if="taskCategory === 0 && taskObjectEject" class="task-detail-modal">
                <!-- 常规任务详情内容保持不变 -->

                <div class="task-content-modal">
                  <!-- ... 常规任务详情内容 ... -->
                  <!-- 常规任务详情 -->
                  <div v-if="taskCategory === 0 && taskObjectEject" class="task-detail-content">
                    <div class="task-header">
                      <h2 class="task-title">{{ taskObject.taskName }}</h2>
                      <Tag :color="getTaskStatusColor(taskObject.status)" class="status-tag">
                        {{ getTaskStatusText(taskObject.status) }}
                      </Tag>
                    </div>

                    <div class="task-description-section">
                      <p class="task-description" v-html="taskObject.taskDesci"></p>
                    </div>

                    <!-- 等级限制 -->
                    <div v-if="taskObject.minLv !== null" class="task-level">
                      <Icon type="ios-stats" />
                      <span>等级限制: {{ taskObject.minLv }} - {{ taskObject.maxLv }}</span>
                    </div>

                    <!-- 任务要求 -->
                    <div v-if="taskObject.needRule && taskObject.needRule.length > 0" class="task-requirements">
                      <h3 class="section-title">
                        <Icon type="ios-list-box" />
                        任务要求
                      </h3>
                      <div
                        v-for="(dtl, index) in taskObject.needRule"
                        :key="dtl.taskId"
                        class="requirement-item"
                        :class="{'completed': dtl.dtlSubNum >= dtl.dtlNeedNum}"
                      >
                        <div class="requirement-info">
                        <span :class="getRequirementClass(dtl.dtlType)">
                          <Icon :type="getRequirementIcon(dtl.dtlType)" />
                          {{ getRequirementText(dtl.dtlType) }} {{ dtl.dtlNeedName }}
                        </span>
                          <span class="progress-text">
                          {{ dtl.dtlSubNum || 0 }}/{{ dtl.dtlNeedNum }}
                        </span>
                        </div>
                        <div class="requirement-actions">
                          <Progress
                            v-if="taskObject.status === 1"
                            :percent="Math.min(100, ((dtl.dtlSubNum || 0) / dtl.dtlNeedNum) * 100)"
                            size="small"
                            style="width: 120px;"
                          />
                          <Icon
                            v-if="taskObject.status === 1 && dtl.dtlType === 'mat' && dtl.dtlSubNum < dtl.dtlNeedNum"
                            @click="submitTask(dtl.dtlNeedId, dtl.dtlId)"
                            type="md-add-circle"
                            class="submit-icon"
                            title="提交材料"
                          />
                        </div>
                      </div>

                      <!-- 材料提交弹窗 -->
                      <div v-if="subMatEject" class="material-submit">
                        <h4>提交任务材料</h4>
                        <Select v-model="matPackId" style="width: 200px; margin: 8px 0"  placeholder="选择材料">
                          <Option
                            v-for="item in materialSmallList"
                            :value="item.packItemId"
                            :key="item.packItemId"
                          >
                            {{ item.itemName }} * {{ item.itemNum }}
                          </Option>
                        </Select>
                        <Input
                          v-model="subTaskNum"
                          type="Number"
                          placeholder="请输入提交数量"
                          style="margin-bottom: 8px; width: 200px;"
                          :max="getMaxSubmitNum()"
                          :min="1"
                        />
                        <Button
                          type="primary"
                          @click="submitMatTask(currentDtlId)"
                          style="margin-left: 8px;"
                          :disabled="!matPackId || !subTaskNum || subTaskNum <= 0"
                        >
                          提交材料
                        </Button>
                      </div>
                    </div>

                    <!-- 任务奖励 -->
                    <div v-if="taskObject.rewardRule && taskObject.rewardRule.length > 0" class="task-rewards">
                      <h3 class="section-title">
                        <Icon type="ios-gift" />
                        任务奖励
                      </h3>

                      <!-- 指定奖励选择 -->
                      <div v-if="taskObject.appoint == 1" class="reward-selection">
                        <p class="reward-tip">请选择一项奖励：</p>
                        <RadioGroup v-model="rewardId" vertical>
                          <Radio
                            v-for="(dtl, index) in taskObject.rewardRule"
                            :key="dtl.itemId"
                            :label="dtl.itemId"
                            class="reward-item"
                          >
                            <Icon type="ios-cube" />
                            {{ dtl.typeDec }} {{ dtl.itemName }} * {{ dtl.dropNum }}
                          </Radio>
                        </RadioGroup>
                      </div>

                      <!-- 固定奖励 -->
                      <div v-else class="fixed-rewards">
                        <div
                          v-for="(dtl, index) in taskObject.rewardRule"
                          :key="dtl.itemId"
                          class="reward-item"
                        >
                          <Icon type="ios-cube" />
                          {{ dtl.typeDec }} {{ dtl.itemName }} * {{ dtl.dropNum }}
                        </div>
                      </div>

                      <div v-if="taskObject.sectContr !== null" class="sect-contribution">
                        <Icon type="ios-people" />
                        宗门贡献: {{ taskObject.sectContr }}
                      </div>
                    </div>

                    <!-- 任务操作 -->
                    <div class="task-actions">
                      <div class="action-left">
                        <Tooltip content="刷新任务" placement="top">
                          <Icon
                            type="ios-refresh-circle-outline"
                            size="24"
                            @click="refreshTask()"
                            class="refresh-icon"
                          />
                        </Tooltip>
                      </div>
                      <div class="action-right">
                        <Button
                          v-if="taskObject.status === 0"
                          type="primary"
                          icon="md-play"
                          @click="receiveTask()"
                          class="action-button"
                        >
                          接取任务
                        </Button>

                        <Button
                          v-if="taskObject.status === 2"
                          type="success"
                          icon="md-download"
                          @click="claimRewards()"
                          class="action-button"
                        >
                          领取奖励1
                        </Button>

                        <Button
                          v-if="taskObject.status === 1"
                          type="info"
                          icon="md-time"
                          disabled
                          class="action-button"
                        >
                          任务进行中
                        </Button>
                      </div>
                    </div>
                  </div>

                </div>
              </div>

              <!-- 空状态 -->
              <div v-else class="empty-detail-modal">
                <Icon type="ios-information-circle-outline" size="48" color="#ccc" />
                <p>请从左侧选择任务查看详情</p>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <!-- 悬赏任务内容 -->
      <div v-if="activeTab === 'reward'" class="tab-pane">
        <Row :gutter="16">
          <Col span="8">
            <!-- 悬赏任务菜单 -->
            <Card class="task-menu-card">
              <Menu :theme="theme2" :open-names="['1']" accordion @on-select="handleRewardSelect" class="reward-menu">
                <Submenu name="1">
                  <template #title>
                    <div class="menu-title">
                      <Icon type="md-clipboard" />
                      <span>悬赏任务</span>
                      <Badge
                        v-if="getUncompletedRewardCount() > 0"
                        :count="getUncompletedRewardCount()"
                        class="menu-badge"
                      />
                    </div>
                  </template>

                  <!-- 操作按钮 -->
                  <MenuItem class="action-menu-item">
                    <Button
                      @click="openRewardList"
                      ghost
                      type="info"
                      long
                      size="small"
                      class="menu-button"
                    >
                      <Icon type="ios-list" />
                      悬赏列表
                    </Button>
                  </MenuItem>

                  <MenuItem class="action-menu-item">
                    <Button
                      style="color: #F43e06; border-color: #F43e06;"
                      @click="publishReward"
                      long
                      size="small"
                      class="menu-button"
                    >
                      <Icon type="ios-add-circle" />
                      发布悬赏
                    </Button>
                  </MenuItem>

                  <!-- 进行中的悬赏任务 -->
                  <MenuGroup v-if="getActiveRewardTasks().length > 0" title="进行中">
                    <MenuItem
                      v-for="item in getActiveRewardTasks()"
                      :key="item.orTaskId"
                      :name="item.orTaskId"
                      class="uncompleted-task reward-menu-item"
                    >
                      <div class="reward-task-info">
                        <Icon type="ios-time" color="#faad14" />
                        <span class="task-name">{{ item.name }}</span>
                        <Tag v-if="item.busStatus === 2" color="orange" size="small">进行中</Tag>
                        <Tag v-if="item.busStatus === 3" color="blue" size="small">待领取</Tag>
                      </div>
                    </MenuItem>
                  </MenuGroup>

                  <!-- 已完成的悬赏任务 -->
                  <MenuGroup v-if="getCompletedRewardTasks().length > 0" title="已完成">
                    <MenuItem
                      v-for="item in getCompletedRewardTasks()"
                      :key="item.orTaskId"
                      :name="item.orTaskId"
                      class="completed-task reward-menu-item"
                    >
                      <div class="reward-task-info">
                        <Icon type="ios-checkmark-circle" color="#52c41a" />
                        <span class="task-name">{{ item.name }}</span>
                        <Tag v-if="item.busStatus === 4" color="green" size="small">已完成</Tag>
                      </div>
                    </MenuItem>
                  </MenuGroup>

                  <!-- 已过期的悬赏任务 -->
                  <MenuGroup v-if="getExpiredRewardTasks().length > 0" title="已过期">
                    <MenuItem
                      v-for="item in getExpiredRewardTasks()"
                      :key="item.orTaskId"
                      :name="item.orTaskId"
                      class="expired-task reward-menu-item"
                    >
                      <div class="reward-task-info">
                        <Icon type="ios-close-circle" color="#ccc" />
                        <span class="task-name">{{ item.name }}</span>
                        <Tag color="default" size="small">已过期</Tag>
                      </div>
                    </MenuItem>
                  </MenuGroup>

                  <!-- 空状态 -->
                  <div v-if="myJbOrTaskList.length === 0" class="empty-reward-tasks">
                    <p>暂无悬赏任务</p>
                  </div>
                </Submenu>
              </Menu>
            </Card>
          </Col>

          <Col span="16">
            <Card class="task-detail-card">
              <!-- 悬赏任务详情 -->
              <div v-if="taskCategory === 2 && taskOrObject" class="reward-task-detail">
                <div class="task-header">
                  <h2 class="task-title">{{ taskOrObject.name }}</h2>
                  <Tag :color="getRewardStatusColor(taskOrObject.busStatus)" class="status-tag">
                    {{ getRewardStatusText(taskOrObject.busStatus) }}
                  </Tag>
                </div>

                <div class="task-content">
                  <!-- 完成状态图片 -->
                  <div v-if="taskOrObject.busStatus === 3 || taskOrObject.busStatus === 4" class="status-image">
                    <img src="@/assets/success.png" alt="任务完成" />
                  </div>

                  <div class="task-description-section">
                    <p class="task-description" v-html="taskOrObject.taskDesc"></p>
                  </div>

                  <!-- 悬赏信息 -->
                  <div class="reward-info">
                    <h3 class="section-title">
                      <Icon type="ios-gift" />
                      悬赏信息
                    </h3>
                    <div class="info-grid">
                      <div class="info-item">
                        <Icon type="ios-cube" color="#2f90b9" />
                        <span class="info-label">悬赏物品:</span>
                        <span class="info-value">{{ taskOrObject.goodName }}</span>
                      </div>
                      <div class="info-item">
                        <Icon type="ios-cube" color="#2f90b9" />
                        <span class="info-label">悬赏数量:</span>
                        <span class="info-value">{{ taskOrObject.goodNum }}</span>
                      </div>
                      <div class="info-item">
                        <Icon type="ios-swap" color="#801DAE" />
                        <span class="info-label">付出物品:</span>
                        <span class="info-value">{{ taskOrObject.interchangeName }}</span>
                      </div>
                      <div class="info-item">
                        <Icon type="ios-swap" color="#801DAE" />
                        <span class="info-label">付出数量:</span>
                        <span class="info-value">{{ taskOrObject.interchangeNum }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 任务详情 -->
                  <div class="task-meta">
                    <h3 class="section-title">
                      <Icon type="ios-information-circle" />
                      任务详情
                    </h3>
                    <div class="info-grid">
                      <div class="info-item">
                        <Icon type="ios-person" color="#1890ff" />
                        <span class="info-label">悬赏人:</span>
                        <span class="info-value">{{ taskOrObject.sellerName }}</span>
                      </div>
                      <div class="info-item">
                        <Icon type="ios-calendar" color="#52c41a" />
                        <span class="info-label">期限:</span>
                        <span class="info-value">{{ taskOrObject.dayNum }} 天</span>
                      </div>
                      <div class="info-item">
                        <Icon type="ios-cash" color="#f5222d" />
                        <span class="info-label">押金:</span>
                        <span class="info-value">{{ taskOrObject.price }} 灵石</span>
                      </div>
                      <div class="info-item" v-if="taskOrObject.buyTime">
                        <Icon type="ios-time" color="#722ed1" />
                        <span class="info-label">揭榜时间:</span>
                        <span class="info-value">{{ taskOrObject.buyTime }}</span>
                      </div>
                    </div>
                  </div>

                  <!-- 任务操作 -->
                  <div class="task-actions">
                    <Button
                      v-if="taskOrObject.busStatus === 2"
                      type="error"
                      icon="md-checkmark"
                      @click="claimRewards2()"
                      class="action-button"
                      size="large"
                    >
                      交付悬赏物品
                    </Button>

                    <Button
                      v-if="taskOrObject.busStatus === 1"
                      type="warning"
                      icon="md-hand"
                      @click="jiebang(taskOrObject.orTaskId, 0)"
                      class="action-button"
                      size="large"
                    >
                      揭榜任务
                    </Button>

                    <Button
                      v-if="taskOrObject.busStatus === 3"
                      type="success"
                      icon="md-download"
                      @click="claimRewards3(taskOrObject.orTaskId)"
                      class="action-button"
                      size="large"
                    >
                      领取奖励
                    </Button>

                    <Button
                      v-if="taskOrObject.busStatus === 5"
                      type="default"
                      icon="md-undo"
                      @click="claimRewards3(taskOrObject.orTaskId)"
                      class="action-button"
                      size="large"
                    >
                      退还材料
                    </Button>
                  </div>
                </div>
              </div>

              <!-- 发布悬赏表单 -->
              <div v-if="taskCategory === 1" class="publish-reward-form">
                <div class="form-header">
                  <h3 class="form-title">
                    <Icon type="ios-add-circle" />
                    发布悬赏任务
                  </h3>
                  <p class="form-desc">发布您的悬赏任务，让其他玩家为您完成任务</p>
                </div>

                <Form
                  ref="formValidate"
                  :model="formValidate"
                  :rules="ruleValidate"
                  :label-width="120"
                  class="reward-form"
                >
                  <FormItem label="任务名称" prop="name">
                    <Input v-model="formValidate.name" placeholder="请输入悬赏任务名称" size="large"></Input>
                  </FormItem>

                  <FormItem label="任务描述" prop="desc">
                    <Input
                      v-model="formValidate.desc"
                      type="textarea"
                      :autosize="{minRows: 3, maxRows: 6}"
                      placeholder="请详细描述您的悬赏任务要求..."
                      size="large"
                    ></Input>
                  </FormItem>

                  <Row :gutter="16">
                    <Col span="12">
                      <FormItem label="悬赏物品" prop="rewardId">
                        <Select v-model="formValidate.rewardId" placeholder="选择悬赏物品" size="large">
                          <Option
                            v-for="item in materialExchangeList"
                            :value="item.itemId"
                            :key="item.itemId"
                            :label="item.itemName"
                          >
                            <div class="reward-option" >
                              <span class="item-name">{{ item.itemName }}</span>
                              <span class="item-type">『{{ item.typeDec }}』</span>
                            </div>
                          </Option>
                        </Select>
                      </FormItem>
                    </Col>
                    <Col span="12">
                      <FormItem label="付出物品" prop="exchangeId">
                        <Select v-model="formValidate.exchangeId" placeholder="选择交换物品" size="large">
                          <Option
                            v-for="item in smallExchangeList"
                            :value="item.packItemId"
                            :key="item.packItemId"
                            :label="item.itemName"
                          >
                            <div class="exchange-option">
                              <span class="item-name">{{ item.itemName }}</span>
                              <span class="item-count">* {{ item.itemNum }}</span>
                              <span class="item-type">『{{ item.typeDec }}』</span>
                            </div>
                          </Option>
                        </Select>
                      </FormItem>
                    </Col>

                  </Row>

                  <Row :gutter="16">
                    <Col span="12">
                      <FormItem label="悬赏数量" prop="rewardNum">
                        <InputNumber
                          v-model="formValidate.rewardNum"
                          placeholder="输入物品数量"
                          :min="1"
                          style="width: 100%"
                          size="large"
                        ></InputNumber>
                      </FormItem>
                    </Col>
                    <Col span="12">
                      <FormItem label="付出数量" prop="exchangeNum">
                        <InputNumber
                          v-model="formValidate.exchangeNum"
                          placeholder="输入交换数量"
                          :min="1"
                          style="width: 100%"
                          size="large"
                        ></InputNumber>
                      </FormItem>
                    </Col>
                  </Row>

                  <FormItem label="悬赏天数" prop="exchangeDay">
                    <Select v-model="formValidate.exchangeDay" placeholder="选择悬赏天数" size="large" placement="top" >
                      <Option value="1" label="今日">
                        <div class="day-option">
                          <span class="day-text">今日</span>
                          <span class="day-tip">该时较短请注意</span>
                        </div>
                      </Option>
                      <Option value="2" label="两日">
                        <div class="day-option" >
                          <span class="day-text">两日</span>
                          <span class="day-tip">两日时间</span>
                        </div>
                      </Option>
                      <Option value="3" label="三日">
                        <div class="day-option">
                          <span class="day-text">三日</span>
                          <span class="day-tip">三日时间足以</span>
                        </div>
                      </Option>
                    </Select>
                  </FormItem>

                  <FormItem>
                    <Button
                      type="error"
                      @click="handleSubmit('formValidate')"
                      icon="md-send"
                      size="large"
                      class="submit-button"
                    >
                      发布悬赏
                    </Button>
                    <Button
                      @click="handleReset('formValidate')"
                      style="margin-left: 16px"
                      icon="md-refresh"
                      size="large"
                    >
                      清空表单
                    </Button>

                    <Poptip
                      transfer
                      trigger="hover"
                      style="float: right;"
                      placement="left"
                    >
                      <Button type="dashed" size="large" icon="ios-help-circle-outline">
                        悬赏规则说明
                      </Button>
                      <div slot="content" class="reward-rules">
                        <h4>悬赏流程：</h4>
                        <p>发布悬赏 → 玩家揭榜 → 交付物品 → 领取奖励</p>
                        <h4>注意事项：</h4>
                        <p>• 每人每天仅可发布两个悬赏任务</p>
                        <p>• 提交悬赏需要交付押金</p>
                        <p>• 悬赏发布后不可修改</p>
                        <p>• 付出物品将从背包立即扣除</p>
                      </div>
                    </Poptip>
                  </FormItem>
                </Form>
              </div>

              <!-- 空状态 -->
              <div v-else-if="taskCategory === 0" class="empty-reward-state">
                <div class="empty-content">
                  <Icon type="ios-clipboard-outline" size="64" color="#ccc" />
                  <h3>悬赏任务</h3>
                  <p>请从左侧选择悬赏任务查看详情，或发布新的悬赏</p>
                  <Button
                    type="primary"
                    icon="ios-add"
                    @click="publishReward"
                    style="margin-top: 16px;"
                  >
                    发布悬赏
                  </Button>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <!-- Tab页签 -->
      <div class="bottom-tabs">
        <Tabs v-model="activeTab" class="task-tabs-bottom">
          <TabPane label="常规任务" name="normal" icon="md-list">
            <!-- 内容已经在上面渲染 -->
          </TabPane>
          <TabPane label="悬赏任务" name="reward" icon="md-clipboard">
            <!-- 内容已经在上面渲染 -->
          </TabPane>
        </Tabs>
      </div>
    </div>
    <!-- 悬赏列表弹窗 -->
    <Modal
      width="900"
      title="悬赏任务列表"
      v-model="tradingBankEject"
      :styles="{ top: '60px' }"
      class="nested-modal"
    >
      <Tabs>
        <TabPane label="可揭榜悬赏">
          <div class="search-bar">
            <Input
              v-model="orTaskName"
              placeholder="请输入悬赏任务名称..."
              style="width: 300px; margin-right: 10px;"
              clearable
              size="small"
            />
            <Button type="primary" @click="rewardList(1)" size="small">查询</Button>
          </div>

          <Table
            border
            :columns="columnsTuzing"
            :data="orTaskList"
            size="small"
            class="compact-table"
          >
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button
                type="primary"
                size="small"
                v-if="row.busStatus === 1"
                @click="jiebang(row.orTaskId, index)"
              >
                揭榜
              </Button>
            </template>
          </Table>

          <div style="margin-top: 16px; text-align: center;">
            <Page
              :total="total"
              :page-size="pageSize"
              @on-change="changepage"
              size="small"
              show-elevator
              show-sizer
            />
          </div>
        </TabPane>

        <TabPane label="我的悬赏">
          <Table
            border
            :columns="columnsTuzing"
            :data="myOrTaskList"
            size="small"
            class="compact-table"
          >
            <template #name="{ row }">
              <strong>{{ row.name }}</strong>
            </template>
            <template #action="{ row, index }">
              <Button
                type="primary"
                size="small"
                v-if="row.busStatus === 3"
                @click="claimRewards3(row.orTaskId)"
              >
                领取奖励
              </Button>
              <Button
                type="error"
                size="small"
                v-if="row.busStatus === 5"
                @click="claimRewards3(row.orTaskId)"
              >
                退还材料
              </Button>
            </template>
          </Table>
        </TabPane>
      </Tabs>
    </Modal>

    <!-- 揭榜确认弹窗 -->
    <Modal v-model="jiebangEject" title="揭榜确认" @on-ok="show4()" width="360">
      <p>确定揭榜这个悬赏吗？</p>
    </Modal>

  </div>
</template>
<script>
export default {
  name: "TaskSystemModal",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 新增Tab相关数据
      activeTab: 'normal', // 默认选中常规任务
      // 原有数据保持不变
      showTaskStatistics: false,
      openNames: ['1', '2', '3', '4'],
      theme: 'light',
      theme2: 'light',
      // 新增提交材料相关数据
      currentDtlId: null, // 当前要提交的任务详情ID
      currentNeedId: null, // 当前需要的材料ID
      // 表单数据
      formValidate: {
        charaId: '',
        name: '',
        rewardId: '',
        rewardNum: 1,
        interest: [],
        exchangeId: '',
        exchangeNum: 1,
        exchangeDay: '1',
        desc: ''
      },

      // 表单验证规则
      ruleValidate: {
        name: [
          { required: true, message: '悬赏任务名称必填', trigger: 'blur' }
        ],
        rewardId: [
          { required: true, message: '请选择悬赏物品', trigger: 'change' }
        ],
        rewardNum: [
          {
            required: true,
            message: '请输入悬赏数量',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入悬赏数量'));
              } else if (Number(value) <= 0) {
                callback(new Error('悬赏数量必须大于0'));
              } else {
                callback();
              }
            }
          }
        ],
        exchangeId: [
          { required: true, message: '请选择付出物品', trigger: 'change' }
        ],
        exchangeNum: [
          {
            required: true,
            message: '请输入付出数量',
            trigger: 'blur',
            validator: (rule, value, callback) => {
              if (value === null || value === undefined || value === '') {
                callback(new Error('请输入付出数量'));
              } else if (Number(value) <= 0) {
                callback(new Error('付出数量必须大于0'));
              } else {
                callback();
              }
            }
          }
        ],
        desc: [
          { required: true, message: '请输入任务描述', trigger: 'blur' },
          { type: 'string', min: 5, message: '描述至少5个字', trigger: 'blur' }
        ]
      },
      // 表格列配置
      columnsTuzing: [
        {
          title: '悬赏',
          key: 'name',
          width: 120
        },
        {
          title: '悬赏描述',
          key: 'taskDesc',
          width: 150
        },
        {
          title: '悬赏人',
          key: 'sellerName',
          width: 80
        },
        {
          title: '悬赏物品',
          key: 'goodName',
          width: 120,
          render: (h, params) => {
            let displayText = params.row.goodName;
            if (params.row.goodNum != null) {
              displayText = displayText + "*" + params.row.goodNum;
            }
            return h('span', displayText);
          }
        },
        {
          title: '交换物品',
          key: 'interchangeName',
          width: 120,
          render: (h, params) => {
            let displayText = params.row.interchangeName;
            if (params.row.interchangeNum != null) {
              displayText = displayText + "*" + params.row.interchangeNum;
            }
            return h('span', displayText);
          }
        },
        {
          title: '赏金',
          key: 'price',
          width: 80
        },
        {
          title: '悬赏状态',
          key: 'busStatus',
          width: 90,
          render: (h, params) => {
            switch (params.row.busStatus) {
              case 1:
                return h('Tag', { props: { color: 'blue' } }, '未接取');
              case 2:
                return h('Tag', { props: { color: 'orange' } }, '悬赏中');
              case 3:
                return h('Tag', { props: { color: 'green' } }, '待领取');
              case 4:
                return h('Tag', { props: { color: 'success' } }, '已完成');
              case 5:
                return h('Tag', { props: { color: 'default' } }, '已过期');
              default:
                return h('span', '未知');
            }
          },
        },
        {
          title: '操作',
          slot: 'action',
          width: 80,
          align: 'center'
        }
      ],

      // 状态数据
      tradingBankEject: false,
      orTaskName: '',
      pageSize: 10,
      total: 0,
      orTaskList: [],
      myOrTaskList: [],
      myJbOrTaskList: [],
      playersList: [],
      subTaskEject: false,
      subMatEject: false,
      subTaskNum: 0,
      matPackId: "",
      materialList: [],
      materialExchangeList: [],
      materialSmallList: [],
      smallExchangeList: [],
      playersList1: [],
      playersList2: [],
      playersList3: [],
      playersList4: [],
      taskObjectEject: false,
      jiebangEject: false,
      jbTaskId: "",
      jbIndex: 0,
      taskObject: {},
      taskOrObject: {},
      taskCategory: 0,
      rewardId: 0,
    }
  },

  computed: {
    totalTaskCount() {
      return this.playersList.length + this.myJbOrTaskList.length;
    },

    completedTaskCount() {
      const normalCompleted = this.playersList.filter(task => this.isTaskCompleted(task)).length;
      const rewardCompleted = this.getCompletedRewardTasks().length;
      return normalCompleted + rewardCompleted;
    },

    uncompletedTaskCount() {
      const normalUncompleted = this.playersList.filter(task => !this.isTaskCompleted(task)).length;
      const rewardUncompleted = this.getActiveRewardTasks().length;
      return normalUncompleted + rewardUncompleted;
    }
  },

  watch: {
    activeTab(newTab) {
      // Tab切换时重置选中状态
      if (newTab === 'normal') {
        this.taskCategory = 0;
      } else if (newTab === 'reward') {
        this.taskCategory = 0; // 重置为悬赏任务列表状态
      }
    },

    visible(newVal) {
      if (newVal) {
        // 弹窗打开时自动刷新数据
        this.refreshAllTasks();
      }
    }
  },

  mounted() {
    if (this.visible) {
      this.getPlaters();
    }
  },

  methods: {
    // 新增方法：刷新所有任务
    refreshAllTasks() {
      this.getPlaters();
      this.myRewardList(1);
      this.myRewardList(2);
      this.$Notice.success({ title: "所有任务列表已刷新" });
    },
    // 修改任务选择方法，切换到常规任务Tab
    handleTaskSelect(name) {
      this.activeTab = 'normal'; // 确保在常规任务Tab
      const task = this.playersList.find(item => item.taskId == name);
      if (task) {
        this.taskObject = task;
        this.taskObjectEject = true;
        this.taskCategory = 0;
      }
    },

    // 修改悬赏任务选择方法，切换到悬赏任务Tab
    handleRewardSelect(name) {
      this.activeTab = 'reward'; // 确保在悬赏任务Tab
      const task = this.myJbOrTaskList.find(item => item.orTaskId == name);
      if (task) {
        this.taskOrObject = task;
        this.taskCategory = 2;
      }
    },
    publishReward() {
      this.activeTab = 'reward';
      this.taskCategory = 1;
      this.gainExchangeItemList();
    },

    openRewardList() {
      this.activeTab = 'reward';
      this.rewardList(1);
    },
    // 修改发布悬赏方法，切换到悬赏任务Tab
    selectTaskCate(value) {
      this.activeTab = 'reward'; // 切换到悬赏任务Tab
      this.taskCategory = value;
      this.gainExchangeItemList();
    },

    // 修改悬赏列表方法，切换到悬赏任务Tab
    rewardList(index) {
      this.tradingBankEject = true;
      this.$http.post("gameTask/getOfferRewardList?page=" + index + "&pageSize=" + this.pageSize + '&name=' + this.orTaskName).then((res) => {
        this.orTaskList = res.data.rows;
        this.total = res.data.records;
      }).catch((err) => {
        this.$Notice.info({ title: '暂无悬赏任务可接取!' });
      });
    },
    // 判断任务是否完成
    isTaskCompleted(task) {
      return task.status === 2 || task.status === 3;
    },

    // 获取未完成任务
    getUncompletedTasks(taskList) {
      return taskList.filter(task => !this.isTaskCompleted(task));
    },

    // 获取已完成任务
    getCompletedTasks(taskList) {
      return taskList.filter(task => this.isTaskCompleted(task));
    },

    // 获取未完成任务数量
    getUncompletedCount(taskList) {
      return this.getUncompletedTasks(taskList).length;
    },

    // 悬赏任务分类方法
    getActiveRewardTasks() {
      return this.myJbOrTaskList.filter(task =>
        task.busStatus === 1 || task.busStatus === 2 || task.busStatus === 3
      );
    },

    getCompletedRewardTasks() {
      return this.myJbOrTaskList.filter(task => task.busStatus === 4);
    },

    getExpiredRewardTasks() {
      return this.myJbOrTaskList.filter(task => task.busStatus === 5);
    },

    getUncompletedRewardCount() {
      return this.getActiveRewardTasks().length;
    },

    // 获取任务状态颜色
    getTaskStatusColor(status) {
      const colorMap = {
        0: 'blue',    // 未接取
        1: 'orange',  // 进行中
        2: 'green',   // 待领取
        9: 'green'    // 已完成
      };
      return colorMap[status] || 'default';
    },

    // 获取任务状态文本
    getTaskStatusText(status) {
      const textMap = {
        0: '未接取',
        1: '进行中',
        2: '待领取',
        3: '已完成'
      };
      return textMap[status] || '未接取';
    },

    // 获取悬赏任务状态颜色
    getRewardStatusColor(status) {
      const colorMap = {
        1: 'blue',    // 未接取
        2: 'orange',  // 进行中
        3: 'green',   // 待领取
        4: 'success', // 已完成
        5: 'default'  // 已过期
      };
      return colorMap[status] || 'default';
    },

    // 获取悬赏任务状态文本
    getRewardStatusText(status) {
      const textMap = {
        1: '未接取',
        2: '进行中',
        3: '待领取',
        4: '已完成',
        5: '已过期'
      };
      return textMap[status] || '未知状态';
    },

    // 处理任务列表数据
    processTaskList(taskList) {
      this.playersList = taskList;
      this.playersList1 = [];
      this.playersList2 = [];
      this.playersList3 = [];
      this.playersList4 = [];

      taskList.forEach(item => {
        if (item.status == null) {
          item.status = 0;
        }

        // 设置状态文本
        switch (item.status) {
          case 0:
          case null:
            item.statusMsg = "未接取";
            break;
          case 1:
            item.statusMsg = "进行中";
            break;
          case 2:
            item.statusMsg = "待领取";
            break;
          case 9:
            item.statusMsg = "已完成";
            break;
          default:
            item.statusMsg = "";
        }

        // 分类任务
        switch (item.taskType) {
          case 'mainTask':
            this.playersList1.push(item);
            break;
          case 'actTask':
            this.playersList2.push(item);
            break;
          case 'sectTask':
            if (item.status !== 9) {
              this.playersList3.push(item);
            }
            break;
          case 'guideTask':
            this.playersList4.push(item);
            break;
        }
      });
    },

    // 其他原有方法保持不变
    getRequirementClass(type) {
      const classMap = {
        'map': 'map-requirement',
        'mat': 'material-requirement',
        'monster': 'monster-requirement',
        'boss': 'boss-requirement',
        'note': 'note-requirement'
      };
      return classMap[type] || '';
    },

    getRequirementIcon(type) {
      const iconMap = {
        'map': 'ios-navigate-outline',
        'mat': 'ios-leaf-outline',
        'monster': 'ios-bonfire-outline',
        'boss': 'ios-bug-outline',
        'note': 'ios-brush-outline'
      };
      return iconMap[type] || '';
    },

    getRequirementText(type) {
      const textMap = {
        'map': '探索',
        'mat': '收集',
        'monster': '消灭',
        'boss': '讨伐',
        'note': '完成'
      };
      return textMap[type] || '';
    },

    // 原有的其他方法...
    getPlaters() {
      this.myRewardList(1);
      this.myRewardList(2);
      this.subMatEject = false;

      this.materialList = this.$store.state.materialList;

      this.$http.post("/gameTask/queryTaskList?charaId=" + this.getCookie("charaId"), {
        headers: {
          'Authorization': this.getCookie("token")
        }
      }).then((res) => {
        this.processTaskList(res.data.data);
      });
    },

    submitTask(dtlNeedId, dtlId) {
      this.subMatEject = true;
      this.materialSmallList = [];
      this.smallExchangeList = [];

      this.currentNeedId = dtlNeedId;
      this.currentDtlId = dtlId;
      this.subMatEject = true;
      this.matPackId = "";
      this.subTaskNum = 0;

      for (let i = 0; i < this.materialList.length; i++) {
        if (this.materialList[i].itemId == dtlNeedId) {
          this.materialSmallList.push(this.materialList[i]);
        }
        if (this.materialList[i].isExchange === 1) {
          this.smallExchangeList.push(this.materialList[i]);
        }
      }
    },

    refreshMaterialPackage() {
      this.$http
        .post("/gameChara/getCharaMaterial/?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          this.materialList = res.data.data;
        })
        .catch((err) => {
          this.$Notice.warning({ title: "获取材料包裹失败,请联系管理员" });
        });
    },

    gainExchangeItemList() {
      this.$http
        .post("/gameMarket/gainExchangeItemList/?charaId=" + this.getCookie("charaId"))
        .then((res) => {
          //this.$Notice.success({ title: res.data.msg });
          this.materialExchangeList = res.data.data;
          this.materialList = this.$store.state.materialList;
          this.smallExchangeList = [];

          for (let i = 0; i < this.materialList.length; i++) {
            if (this.materialList[i].isExchange === 1) {
              this.smallExchangeList.push(this.materialList[i]);
            }
          }
        })
        .catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
    },
    // 获取最大可提交数量
    getMaxSubmitNum() {
      if (!this.matPackId) return 0;
      const material = this.materialSmallList.find(item => item.packItemId == this.matPackId);
      return material ? material.itemNum : 0;
    },
    submitMatTask(dtlId) {
      this.$http.post("/gameTask/submitMatTask?charaId=" +
        this.getCookie("charaId") +
        "&taskId=" + dtlId +
        "&packId=" + this.matPackId +
        "&packNum=" + this.subTaskNum
      ).then((res) => {
        this.$Notice.success({ title: res.data.msg });
        this.refreshTask();
        this.refreshMaterialPackage();
      }).catch((err) => {
        this.$Notice.warning({ title: err.data.msg });
      });
    },


    refreshTask() {
      this.$http.post("/gameTask/refreshTask?charaId=" +
        this.getCookie("charaId") +
        "&taskId=" + this.taskObject.taskId
      ).then((res) => {
        this.subMatEject = false;
        this.taskObject = res.data.data;
        this.taskObjectEject = true;
        this.taskCategory = 0;

        if (this.taskObject.status === null) {
          this.taskObject.status = 0;
        }

        this.materialList = this.$store.state.materialList;
        this.$Notice.success({ title: "已刷新" });
      }).catch((err) => {
        this.$Notice.warning({ title: err.data.msg });
      });
    },

    // 其他悬赏相关方法
    jiebang(taskId, index) {
      this.jiebangEject = true;
      this.jbTaskId = taskId;
      this.jbIndex = index;
    },

    show4() {
      this.$http.post("/gameTask/playersUnveiling?charaId=" +
        this.getCookie("charaId") +
        "&orId=" + this.jbTaskId
      ).then((res) => {
        this.$Notice.success({ title: res.data.msg });
        this.orTaskList.splice(this.jbIndex, 1);
        this.myRewardList(2);
      }).catch((err) => {
        this.$Notice.warning({ title: err.data.msg });
      });
    },

    claimRewards2() {
      this.$http.post("/gameTask/playersDeliveryBounty?charaId=" +
        this.getCookie("charaId") +
        "&orId=" + this.taskOrObject.orTaskId
      ).then((res) => {
        this.taskOrObject.busStatus = 3;
        this.$Notice.success({ title: res.data.msg });
      }).catch((err) => {
        this.$Notice.warning({ title: err.data.msg });
      });
    },

    claimRewards3(taskId) {
      this.$http.post("/gameTask/playersRewardBounty?charaId=" +
        this.getCookie("charaId") +
        "&orId=" + taskId
      ).then((res) => {
        this.$Notice.success({ title: res.data.msg });
        this.myRewardList(1);
      }).catch((err) => {
        this.$Notice.warning({ title: err.data.msg });
      });
    },

    receiveTask() {
      this.$http.post("/gameTask/pickUpTask?charaId=" +
        this.getCookie("charaId") +
        "&taskId=" + this.taskObject.taskId
      ).then((res) => {
        this.$Notice.success({ title: res.data.msg });
        // 刷新常规任务列表
        this.refreshTask();
        this.getPlaters();

        // 如果是悬赏任务，刷新悬赏任务列表
        if (this.activeTab === 'reward' || this.taskObject.taskType === 'reward') {
          this.myRewardList(1); // 刷新我的悬赏列表
          this.myRewardList(2); // 刷新接取的悬赏列表
        }
      });
    },

    claimRewards() {
      if (this.taskObject.appoint === 1 && this.rewardId == 0) {
        this.$Notice.warning({ title: "必须指定奖励!" });
      } else {
        this.$http.post("/gameTask/claimRewards?charaId=" +
          this.getCookie("charaId") +
          "&taskId=" + this.taskObject.taskId +
          "&rewardId=" + this.rewardId
        ).then((res) => {
          this.$Notice.success({ title: res.data.msg });
          // 刷新任务状态
          this.refreshTask();
          this.getPlaters();

          // 刷新悬赏任务列表
          if (this.activeTab === 'reward') {
            this.myRewardList(1);
            this.myRewardList(2);
          }
        }).catch((err) => {
          this.$Notice.warning({ title: err.data.msg });
        });
      }
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          // 确保数值类型正确
          const formData = {
            ...this.formValidate,
            rewardNum: Number(this.formValidate.rewardNum),
            exchangeNum: Number(this.formValidate.exchangeNum),
            charaId: this.getCookie("charaId")
          };

          console.log('提交表单数据:', formData);

          this.$http.post("gameTask/offerReward", formData).then((res) => {
            this.$Notice.success({ title: res.data.msg });
            this.handleReset('formValidate');
            this.myRewardList(1);
            this.taskCategory = 0;
          }).catch((err) => {
            this.$Notice.error({ title: err.data.msg || '发布悬赏失败' });
          });
        } else {
          this.$Notice.error({
            title: '表单验证失败',
            desc: '请检查表单填写是否正确'
          });
        }
      });
    },

    changepage(index) {
      this.rewardList(index);
    },

    myRewardList(type) {
      this.$http.post("gameTask/getOfferRewardReceivedList?charaId=" +
        this.getCookie("charaId") +
        "&type=" + type
      ).then((res) => {
        if (type === 1) {
          this.myOrTaskList = res.data.data;
        } else {
          this.myJbOrTaskList = res.data.data;
        }
      }).catch((err) => {
        this.$Notice.info({ title: '暂无!' });
      });
    },

    handleReset(name) {
      this.$refs[name].resetFields();
      // 手动重置数值字段的默认值
      this.$nextTick(() => {
        this.formValidate.rewardNum = 1;
        this.formValidate.exchangeNum = 1;
      });
    },

    getCookie(name) {
      // Cookie获取逻辑
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
    }
  }
}
</script>

<style scoped>
.task-detail-content {
  padding: 16px;
}

.task-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f0f0f0;
}

.task-title {
  margin: 0;
  font-size: 20px;
  font-weight: bold;
  color: #333 !important;
}

.task-description-section {
  margin-bottom: 20px;
}

.task-description {
  font-size: 14px;
  line-height: 1.6;
  color: #666;
  white-space: pre-wrap;
}

.task-level {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 8px 12px;
  background: #f0f8ff;
  border-radius: 4px;
  font-size: 13px;
  color: #1890ff;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 20px 0 12px 0;
  font-size: 16px;
  font-weight: bold;
  color: #333;
}

.requirement-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  margin: 6px 0;
  border-radius: 4px;
  border: 1px solid #f0f0f0;
}

.requirement-item.completed {
  background: #f6ffed;
  border-color: #b7eb8f;
}

.requirement-info {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
}

.requirement-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.progress-text {
  font-weight: bold;
  color: #1890ff;
}

.submit-icon {
  cursor: pointer;
  color: #1890ff;
  font-size: 18px;
}

.material-submit {
  margin-top: 16px;
  padding: 16px;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 4px solid #1890ff;
}

.material-submit h4 {
  margin: 0 0 12px 0;
  color: #1890ff;
}

.task-rewards {
  margin-top: 20px;
}

.reward-selection,
.fixed-rewards {
  margin: 12px 0;
}

.reward-tip {
  margin-bottom: 8px;
  color: #666;
  font-size: 13px;
}

.reward-item {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
  padding: 6px 0;
  color: #F43e06;
}

.sect-contribution {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
  padding: 8px 12px;
  background: #fff7e6;
  border-radius: 4px;
  color: #fa8c16;
}

.task-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.action-right {
  display: flex;
  gap: 12px;
}

.refresh-icon {
  cursor: pointer;
  color: #1890ff;
}

.action-button {
  min-width: 120px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.empty-content {
  text-align: center;
  color: #ccc;
}

.empty-content p {
  margin-top: 12px;
  font-size: 14px;
}

/* 任务要求类型颜色 */
.map-requirement { color: #2f90b9; }
.material-requirement { color: #801DAE; }
.monster-requirement { color: #F43e06; }
.boss-requirement { color: #d4380d; }
.note-requirement { color: #722ed1; }



.completed-task {
  color: #52c41a;
  opacity: 0.7;
}
.task-system-modal {
  height: 700px;
  overflow: hidden;
  overflow: hidden;
}
/* 新增Tab样式 */
.task-tabs {
  height: 100%;
}

.task-tabs :deep(.ivu-tabs-content) {
  height: calc(100% - 45px);
  overflow: hidden;
}

.task-tabs :deep(.ivu-tabs-tabpane) {
  height: 100%;
  overflow: hidden;
}

.modal-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  padding: 0 8px;
}

.task-statistics-modal {
  display: flex;
  gap: 16px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #666;
}

.stat-item.completed {
  color: #52c41a;
}

.stat-item.uncompleted {
  color: #ff4d4f;
}

.task-container-modal {
  height: 540px;
  overflow: hidden;
}

/* 紧凑菜单样式 */
.task-menu-card,
.reward-menu-card {
  max-height: 460px;
  width: 280px;
  overflow-y: auto;
}

.compact-menu {
  border: none;
}

.compact-menu-item {
  padding: 8px 6px;
  margin: 2px 0;
  min-height: 32px;
}

.menu-title {
  display: flex;
  align-items: center;
  gap: 8px;
}

.menu-badge {
  margin-left: auto;
}



.action-menu-item {
  padding: 8px 16px;
}

/* 任务详情卡片 */
.task-detail-card {
  height: 100%;
  overflow-y: auto;
}

.task-detail-modal,
.reward-task-detail-modal,
.publish-reward-modal {
  padding: 0px;
}

.task-header-modal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #f0f0f0;
}

.task-title-modal {
  font-weight: bold;
  font-size: 18px;
  color: #333;
  margin: 0;
}

.status-tag {
  margin-left: 10px;
}

.task-content-modal {
  max-height: 454px;
  overflow-y: auto;
}

.task-description-modal {
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  margin-bottom: 16px;
  color: #666;
}

.task-level-modal {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-size: 13px;
  color: #1890ff;
}

.section-title-modal {
  color: #ff4d4f;
  font-size: 14px;
  font-weight: bold;
  margin: 12px 0 8px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.requirement-item-modal {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 6px 0;
  padding: 6px 8px;
  border-radius: 4px;
  font-size: 13px;
}

.requirement-item-modal.completed {
  background-color: #f6ffed;
  border: 1px solid #b7eb8f;
}

.progress-modal {
  display: flex;
  align-items: center;
  gap: 8px;
}

.submit-icon {
  cursor: pointer;
  color: #1890ff;
  margin-left: 8px;
}

.material-submit-modal {
  margin: 12px 0;
  padding: 12px;
  background: #f5f5f5;
  border-radius: 4px;
  border-left: 3px solid #1890ff;
}

.submit-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #1890ff;
}

.task-rewards-modal {
  margin-top: 16px;
}

.reward-item-modal {
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 4px 0;
  font-size: 13px;
  color: #52c41a;
}

.sect-contribution-modal {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  font-size: 13px;
  color: #faad14;
}

.task-actions-modal {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}

.refresh-icon {
  cursor: pointer;
  color: #1890ff;
}

.action-button {
  min-width: 100px;
}

/* 悬赏任务详情样式 */
.reward-info-modal,
.task-meta-modal {
  margin: 12px 0;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 6px 0;
  font-size: 13px;
  color: #666;
}

.status-image-modal {
  float: right;
  margin-left: 16px;
  margin-bottom: 16px;
}

.status-image-modal img {
  width: 120px;
  height: 100px;
}

/* 发布悬赏表单样式 */
.form-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 0px;
  color: #333;
  text-align: center;
}

.compact-form {
  max-height: 480px;
  overflow-y: auto;
}

.compact-form :deep(.ivu-form-item) {
  margin-bottom: 12px;
}

/* 空状态样式 */
.empty-detail-modal {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #ccc;
}

.empty-detail-modal p {
  margin-top: 12px;
  font-size: 14px;
}

.empty-tasks {
  text-align: center;
  padding: 8px;
  color: #999;
  font-size: 12px;
}

/* 搜索栏样式 */
.search-bar-modal {
  margin-bottom: 16px;
}

/* 紧凑表格样式 */
.compact-table :deep(.ivu-table-cell) {
  padding: 8px 4px;
  font-size: 12px;
}

/* 嵌套弹窗样式 */
.nested-modal :deep(.ivu-modal-body) {
  max-height: 500px;
  overflow-y: auto;
}
/* 悬赏任务特定样式 */
.reward-menu {
  border: none;
}

.reward-menu-item {
  padding: 8px 16px;
  margin: 2px 0;
}

.menu-button {
  text-align: left;
}

.reward-task-info {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.task-name {
  flex: 1;
  font-size: 12px;
}

.empty-reward-tasks {
  text-align: center;
  padding: 16px;
  color: #999;
  font-size: 12px;
}

/* 悬赏任务详情样式 */
.reward-task-detail {
  padding: 20px;
}

.status-image {
  float: right;
  margin-left: 20px;
  margin-bottom: 20px;
}

.status-image img {
  width: 120px;
  height: 100px;
}

.reward-info,
.task-meta {
  margin: 20px 0;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #f8f9fa;
  border-radius: 4px;
}

.info-label {
  color: #666;
  font-size: 13px;
}

.info-value {
  font-weight: 500;
  color: #333;
}

/* 发布悬赏表单样式 */
.publish-reward-form {
  padding: 1px;
}

/* 发布悬赏表单样式 */

.form-header {
  text-align: center;
  margin-bottom: 32px;
}

.form-title {
  font-size: 24px;
  color: #333;
  margin-bottom: 8px;
}

.form-desc {
  color: #666;
  font-size: 14px;
}

.reward-form {
  max-width: 600px;
  margin: 0 auto;
}

.reward-option,
.exchange-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item-name {
  font-weight: 500;
}

.item-count {
  color: #1890ff;
  font-weight: bold;
}

.item-type {
  color: #999;
  font-size: 12px;
}

.day-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.day-text {
  font-weight: 500;
}

.day-tip {
  color: #999;
  font-size: 12px;
}

.submit-button {
  min-width: 120px;
}

.reward-rules {
  max-width: 280px;
}

.reward-rules h4 {
  margin: 8px 0 4px 0;
  color: #333;
}

.reward-rules p {
  margin: 4px 0;
  font-size: 12px;
  line-height: 1.4;
  color: #666;
}

/* 空状态样式 */
.empty-reward-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
}

.empty-reward-state .empty-content {
  text-align: center;
  color: #ccc;
}

.empty-reward-state h3 {
  margin: 16px 0 8px 0;
  font-size: 18px;
}

.empty-reward-state p {
  font-size: 14px;
  margin-bottom: 16px;
}

/* 搜索栏样式 */
.search-bar {
  margin-bottom: 16px;
  padding: 0 8px;
}
/* 滚动条优化 */
.task-menu-card::-webkit-scrollbar,
.reward-menu-card::-webkit-scrollbar,
.task-detail-card::-webkit-scrollbar {
  width: 4px;
}

.task-menu-card::-webkit-scrollbar-track,
.reward-menu-card::-webkit-scrollbar-track,
.task-detail-card::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.task-menu-card::-webkit-scrollbar-thumb,
.reward-menu-card::-webkit-scrollbar-thumb,
.task-detail-card::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 2px;
}

.task-menu-card::-webkit-scrollbar-thumb:hover,
.reward-menu-card::-webkit-scrollbar-thumb:hover,
.task-detail-card::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
.task-container-modal {
  height: calc(100% - 60px);
  display: flex;
  flex-direction: column;
}

.tab-content-area {
  flex: 1;
  overflow: hidden;
}

.tab-pane {
  height: 80%;
  overflow: hidden;
}

.bottom-tabs {
  border-top: 1px solid #e8eaec;
  background: #fff;
}

.task-tabs-bottom {
  margin: 0;
}

.task-tabs-bottom :deep(.ivu-tabs-bar) {
  margin-bottom: 0;
  border-bottom: none;
}

.task-tabs-bottom :deep(.ivu-tabs-nav-container) {
  font-size: 14px;
}

.task-tabs-bottom :deep(.ivu-tabs-tab) {
  padding: 12px 16px;
}

/* 确保内容区域正确滚动 */
.tab-content-area .ivu-row {
  height: 100%;
}

.tab-content-area .ivu-col {
  height: 100%;
}

.task-menu-card,
.task-detail-card {
  height: 100%;
  overflow-y: auto;
}
</style>

<style>
/* 全局样式调整 */
.task-modal .ivu-modal-body {
  padding: 16px;
  max-height: 640px;
  overflow: hidden;
}

.nested-modal .ivu-modal-body {
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/playersList.vue